import {Button} from '@chakra-ui/react';
import {Box, Flex, Text} from '@chakra-ui/layout';
import {QuatitySelectorProps} from '../../hooks/quantity-selector';
import {getPlural} from '../../utils/utils';
import {AmountInput} from './amount-input';
import {PricingProps, QuantitySelector} from './pieces-calculator';

interface MobilePiecesCalculatorPops extends PricingProps {
  isOpen: boolean;
  quatitySelectorProps: QuatitySelectorProps;
  goToCheckout: () => void;
  maxPieces: number;
  currencySymbol: string;
}

export const MobilePiecesCalculator: React.FC<MobilePiecesCalculatorPops> = ({
  isOpen,
  quatitySelectorProps,
  goToCheckout,
  maxPieces,
  isDisabled,
  currencySymbol,
}: MobilePiecesCalculatorPops) => {
  const {
    quantity,
    loading,
    amountInput,
    quantityInput,
    incrementQuantity,
    showRoundingMsg,
    showMaxPiecesError,
    decrementQuantity,
  } = quatitySelectorProps;

  return (
    <>
      <Flex pt="24px" pb="20px" px="24px" flexDir="column" flex={1}>
        <Text textStyle="h6" color="darkGrey" textAlign="center">
          How many pieces would you like to own?
        </Text>
        <Flex flex={1} flexDir="column" mt={6}>
          <Box pos="relative">
            <Text textStyle="body3" color="tone3" mb={1}>
              Enter your amount
            </Text>
            <AmountInput
              loading={loading}
              amountInput={amountInput}
              currency={currencySymbol}
              setAutoFocus={isOpen || false}
            />
            {showRoundingMsg ? (
              <Text color="stampRed" textStyle="body3" pos="absolute" mt={2}>
                This rounds up to {quantity} piece{getPlural(quantity)}
              </Text>
            ) : null}
          </Box>
          <Flex flexDir="column" my="32px" alignItems="center" mx={4}>
            <Text textStyle="body3" color="tone3" mb={1}>
              Number of pieces
            </Text>
            <QuantitySelector
              quantityInput={quantityInput}
              showMaxPiecesError={showMaxPiecesError}
              onClickDecrement={decrementQuantity}
              onClickIncrement={incrementQuantity}
              maxPieces={maxPieces}
            />
          </Flex>
          <Flex alignSelf="center">
            <Button
              colorScheme="aqua"
              type="submit"
              size="lg"
              isDisabled={!quantity || isDisabled}
              maxW={{base: 'none', md: '290px'}}
              onClick={goToCheckout}
              py="18px"
              px="72px"
            >
              Continue
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};
